export default "__VITE_ASSET__CK8O0p2G__"